/// <amd-module name="TFS/Services/TfsRestErrorHandlerService.types" />
import { IRestErrorHandlerService } from "VSS/Platform/IPlatformRestErrorHandler";

export type PageType = "signin" | "signout" | "other";

export interface ITfsRestErrorHandlerService extends IRestErrorHandlerService {
    verify(): Promise<{ success: boolean; newUrl?: string }>;
}
